import { useQuery, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const setSelectedFacebookAdAccounts = async (
  accountId: number,
  connectionId: number,
  adAccountIds: number[]
) => {
  return (await request({
    url: `/accounts/${accountId}/facebook/${connectionId}/ad-accounts/selected`,
    method: 'PUT',
    data: { adAccountIds },
  })) as string[]
}

type QueryFnType = typeof setSelectedFacebookAdAccounts

export const useSetSelectedFacebookAdAccounts = ({
  connectionId,
  adAccountsIds,
  config,
}: {
  connectionId: number
  adAccountsIds: number[]
  config?: QueryConfig<QueryFnType>
}) => {
  const queryClient = useQueryClient()
  const { accountId } = useUserStore()
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['setSelectedFacebookAdAccounts', adAccountsIds],
    queryFn: () => setSelectedFacebookAdAccounts(accountId, connectionId, adAccountsIds),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
    },
    ...config,
  })
}
